/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Report_Chart_OrdersInputs */

const vi_report_chart_orders = /** @type {(inputs: Report_Chart_OrdersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn hàng: ${i?.count}`)
};

/**

* @param {Report_Chart_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_chart_orders = /** @type {((inputs: Report_Chart_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Chart_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_chart_orders(inputs)
});